import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";
import { ShieldCheck } from "@phosphor-icons/react";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser, setAuthState, checkAuth } = useApp();
    const processed = useRef(false);

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;

        const hash = window.location.hash || "";
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const sessionId = params.get("session_id");
        if (!sessionId) {
            nav("/login");
            return;
        }

        (async () => {
            try {
                const referralCode = sessionStorage.getItem("legashield_ref") || null;
                sessionStorage.removeItem("legashield_ref");
                const r = await api.post("/auth/google/session", {
                    session_id: sessionId,
                    referral_code: referralCode,
                });
                localStorage.setItem("legashield_token", r.data.token);
                setUser(r.data.user);
                setAuthState("in");
                // clean URL and go to dashboard
                window.history.replaceState({}, document.title, "/dashboard");
                nav("/dashboard", { replace: true, state: { user: r.data.user } });
            } catch (e) {
                console.error("OAuth exchange failed", e);
                await checkAuth();
                nav("/login", { replace: true });
            }
        })();
    }, [nav, setUser, setAuthState, checkAuth]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-shield-paper">
            <div className="text-center">
                <ShieldCheck size={48} weight="duotone" className="mx-auto text-shield-forest animate-pulse" aria-hidden="true" />
                <p className="mt-4 text-shield-muted font-medium">Sichere Anmeldung…</p>
            </div>
        </div>
    );
}
